import { render, staticRenderFns } from "./PermissionsTree.vue?vue&type=template&id=de453b34&scoped=true&"
import script from "./PermissionsTree.vue?vue&type=script&lang=js&"
export * from "./PermissionsTree.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsTree.vue?vue&type=style&index=0&id=de453b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de453b34",
  null
  
)

export default component.exports